function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L44 0 44 44 0 44z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFE",
  d: "M3.216 25.764c1.013 0 1.834.82 1.834 1.833v5.5h5.5c1.012 0 1.833.82 1.833 1.833s-.82 1.834-1.833 1.834H1.383v-9.167c0-1.013.82-1.833 1.833-1.833zm37.568 0c1.012 0 1.833.82 1.833 1.833v9.167H33.45c-1.012 0-1.833-.821-1.833-1.834 0-1.012.82-1.833 1.833-1.833h5.5v-5.5c0-1.013.821-1.833 1.834-1.833zM10.55 7.236c1.012 0 1.833.821 1.833 1.834 0 1.012-.82 1.833-1.833 1.833h-5.5v5.5c0 1.013-.821 1.833-1.834 1.833-1.012 0-1.833-.82-1.833-1.833V7.236h9.167zm32.067 0v9.167c0 1.013-.82 1.833-1.833 1.833s-1.834-.82-1.834-1.833v-5.5h-5.5c-1.012 0-1.833-.82-1.833-1.833s.82-1.834 1.833-1.834h9.167z"
}));

const SvgSquare = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSquare, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/square.af2cd454.svg";
export { ForwardRef as ReactComponent };